import React from 'react';
import { Link } from 'react-router-dom';

import styles from './BecomeRainmaker.scss';

const BecomeRainmaker = () => {
  return (
    <div className={styles.BecomeRainmaker}>
      <h3 className={styles.Title}>Start building your sales team</h3>

      <div className={styles.Description}>
        Rainmakers delivers pre-vetted, ready-to-interview sales talent—fast. Skip the job board
        noise and connect with candidates who are ready to make an impact.
      </div>

      <Link className={styles.Request} to="/employer-signup/">
        Join Now
      </Link>
    </div>
  );
};

export default BecomeRainmaker;
